/**
 * In-app legal documents (same content as public /privacy, /data-deletion, /terms, /credits).
 */

import { Redirect, useLocalSearchParams } from 'expo-router'
import { LegalDocumentScreen } from '../../../components/landing/LegalDocumentScreen/LegalDocumentScreen'
import {
  getLegalDocumentVariantForSlug,
  normalizeRootSlugParam,
} from '../../../src/landing/helpers/legalRootSlug.helper'

export default function AppLegalDocumentRoute() {
  const params = useLocalSearchParams<{ slug?: string | string[] }>()
  const slug = normalizeRootSlugParam(params.slug)
  const variant = getLegalDocumentVariantForSlug(slug)

  if (variant === null) {
    return <Redirect href="/app/" />
  }

  return <LegalDocumentScreen variant={variant} origin="app" />
}
